/* eslint-disable @typescript-eslint/no-explicit-any */

// Synchronize with FrontendPageRoutes on the backend
export type AppRoutes = RecursiveReadonly<{
    index: EpiPageSettings;
    ecommerce: {
        index: EpiPageSettings;
        productOrSection: EpiPageSettings;
        checkout: {
            index: EpiPageSettings;
            orderComplete: EpiPageSettings;
        };
    };
    customerService?: EpiPageSettings;
}>;

type RecursiveEpiPageSettings = EpiPageSettings | { [key: string]: RecursiveEpiPageSettings };

// Tree of routes decoupled from window object
// It must never contain data other than EpiPageSettings
// For such data, use coopSettings
export const appRoutes: AppRoutes = (window as any).routes as AppRoutes satisfies {
    [key: string]: RecursiveEpiPageSettings;
};
